import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                primary: "#002884",
                accent: "#087f23",
                secondary: "#3f50b5",
            }
        }
    }
});
